import { fetchPage } from '@/services/userService';
export const Pages = {
  namespaced: true,
  state: {
    data: null,
    loaded: false,
    statusCode: null,
  },
  getters: {
    loaded: (state: any) => {
      return state.loaded;
    },
    data: (state: any) => {
      return state.data;
    },
    statusCode: (state: any) => {
      return state.statusCode;
    },
    token: (state: any, getters: any, rootState: any, rootGetters: any) => {
      return rootGetters['auth/token'];
    },
    lang: (state: any, getters: any, rootState: any, rootGetters: any) => {
      return rootGetters['auth/lang'];
    },
  },
  mutations: {
    resetData: (state: any) => {
      state.data = null;
    },
    setData: (state: any, data: PageData) => {
      state.data = data;
    },
    setStatusCode: (state: any, data: number) => {
      state.statusCode = data;
    },
    setLoaded: (state: any, bool: boolean) => {
      state.loaded = bool;
    },
  },
  actions: {
    getEntry: async (cxt: any, params: any) => {
      cxt.commit('setLoaded', false);
      const res = await fetchPage({
        name: `${params.slug}`,
        lang: `${cxt.getters.lang}`,
      })
      .then( (response) => {
        // cxt.commit('setData', response.data.datas);
        // cxt.dispatch('head/updateTitle', response.data.datas[0].title, {root: true});
        return response;
      })
      .catch( (e) => {
        console.error(e);
        cxt.commit('setStatusCode', e.status);
        throw Error;
      })
      .finally(() => {
        cxt.commit('setLoaded', true);
      });
      return res;
    },
  },
};
